import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import supabase from '../../services/supabaseClient';

const AuthCallback = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { dispatch } = useAuth();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the current session after OAuth redirect
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) {
          throw sessionError;
        }

        if (session) {
          // Update auth context with user data
          dispatch({
            type: 'LOGIN',
            payload: {
              user: session.user,
              session: session,
              isLoggedIn: true
            }
          });
          
          setLoading(false);
          // Redirect to home/dashboard
          navigate('/');
        } else {
          throw new Error('No session found after authentication');
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err.message || 'Authentication failed');
        setLoading(false);
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleAuthCallback();
  }, [dispatch, navigate]);

  if (loading && !error) {
    return (
      <div className="auth-callback-container" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        flexDirection: 'column'
      }}>
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <p>Completing sign in...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-callback-container" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        flexDirection: 'column',
        padding: '20px'
      }}>
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Authentication Error</h4>
          <p>{error}</p>
          <hr />
          <p className="mb-0">Redirecting to login page...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default AuthCallback;
